<template>
  <select  :id="selectedId" v-model="elementSelect" multiple
           class="form-control is-invalid retirerBordure"
  >
    <option data-placeholder="true"></option>
    <option v-for="item in data" :key="item.id" :value="`${item[''+returnValue]}`">
      {{ item[""+showValue] }}
    </option>
  </select>
</template>

<script>
import SlimSelect from "slim-select";
import md5 from 'md5.js';
import _ from 'lodash';
import moment from 'moment';


export default {
  name: "slimGroupElement",
  props:{
    afficher:Boolean,
    selectedId:String,
    element:Array,
    data:Array,
    returnValue:String,
    showValue:String,
  },

  computed:{
    elementSelect:{
      get:function (){
        return this.element;
      },
      set:function (newValue){
        this.$emit('update:element',newValue);
      }
    }
  },

  data(){
    return {
      slimElement:Object,
    }
  },

  mounted() {

    let id = '#'+this.selectedId;
    let slim = new SlimSelect({
      select: id,
      placeholder: 'Select',
      limit: 5
    });

    this.slimElement = slim;

    if (!this.afficher){
      let element = document.getElementById(this.selectedId);
      if (element){
        element.remove();
        slim.destroy();
      }
    }
  }
}
</script>

<style scoped>

</style>